// JS-Entry des Themes "mybrunex".
//
// Bewusst schlank. Bootstrap-JS kommt NICHT von hier: EasyAdmin bringt es in
// seinem eigenen app.js mit (setzt window.bootstrap) und laedt das selbst.
// Ein zweiter Import wuerde jedes data-bs-*-Element doppelt initialisieren.
import '@fortawesome/fontawesome-pro/css/all.min.css';
import '../styles/app.scss';
// Formular-Widgets (Translatable, Cleave, Icon-Picker): ueberall, wo Symfony-
// Formulare gerendert werden - heute EasyAdmin, spaeter das Portal.
import './forms';

// Fehlerüberwachung (nur mit SENTRY_FRONTEND_DSN): globale Fehler auf allen
// Seiten des Themes, die Vue-Inseln melden sich an ihrem createApp() an.
import { initErrorTracking } from '@shared/error-tracking';

initErrorTracking();
